import { Form } from "react-bootstrap";
import { REGIONS } from "../tricho.utils";
import React from "react";

export default function RegionPicker({ region, setRegion }) {
  return (
    <div className="tricho-region">
      <Form.Label className="m-0 tricho-label">Região da foto</Form.Label>
      <Form.Select
        size="sm"
        value={region}
        onChange={(e) => setRegion(e.target.value)}
        className="tricho-select"
      >
        {REGIONS.map((r) => (
          <option key={r.key} value={r.key}>
            {r.label}
          </option>
        ))}
      </Form.Select>
    </div>
  );
}
